import { appApi } from './app_api';

// Auth lives on the shared appApi instance. The session (current user) is held
// in the `getCurrentUser` query cache — there is no persisted auth slice. On app
// load the root calls useGetCurrentUserQuery() which hits GET /users/me; a 401
// (no/invalid JWT cookie) reads as "logged out". login/register seed the cache
// directly so no extra round-trip is needed; logout wipes the whole API cache.
export const authApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentUser: builder.query({
      query: () => '/users/me',
      transformResponse: (response) => response.user,
      providesTags: ['CurrentUser'],
    }),
    login: builder.mutation({
      query: (credentials) => ({
        url: '/users/login',
        method: 'POST',
        body: credentials, // { user: { phone, password } }
      }),
      transformResponse: (response) => response.user,
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: user } = await queryFulfilled;
          dispatch(appApi.util.upsertQueryData('getCurrentUser', undefined, user));
        } catch {
          // Login failed — nothing to seed.
        }
      },
    }),
    register: builder.mutation({
      query: (user) => ({
        url: '/users',
        method: 'POST',
        body: { user },
      }),
      transformResponse: (response) => response.user,
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: user } = await queryFulfilled;
          dispatch(appApi.util.upsertQueryData('getCurrentUser', undefined, user));
        } catch {
          // Registration failed — nothing to seed.
        }
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: '/users/logout',
        method: 'DELETE',
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } finally {
          // Drop all cached data so no stale user/permission state lingers.
          dispatch(appApi.util.resetApiState());
        }
      },
    }),
  }),
});

export const {
  useGetCurrentUserQuery,
  useLoginMutation,
  useRegisterMutation,
  useLogoutMutation,
} = authApi;
